import { Action } from '@ngrx/store';

export enum LoadingActionTypes {
    SetLoading = '[loading] Set Loading'
}

export class SetLoading implements Action {
    constructor(public payload: boolean) {}
    readonly type = LoadingActionTypes.SetLoading;
}
export type LoadingActionsUnion = SetLoading;
